import styled from 'styled-components';
import { ITheme } from '../../styles/theme';

interface IScoreBar {
  background: string;
  theme: ITheme;
}

export const ScoreBar = styled.div<IScoreBar>`
  ${({theme, background}: IScoreBar) => `
    background: ${background};
    width: ${theme.layout.spacing.deka};
    height: ${theme.layout.spacing.mikro};
    border-radius: ${theme.layout.spacing.centy};
  `}
`;